module.exports = __webpack_public_path__ + "static/image8-d9f8e22ed89692d41c01d01367077dd1.jpeg";